import CommentIcon from "@mui/icons-material/Comment";
import {
  Alert,
  Box,
  Button,
  Chip,
  CircularProgress,
  Container,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  List,
  ListItem,
  MenuItem,
  Paper,
  Select,
  Stack,
  TextField,
  Badge,
  Tooltip,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import SolicitacaoResumoHeader from "../../components/solicitacao/SolicitacaoResumoHeader";
import api from "../../services/api";
import licencasService from "../../services/licencas";
import { isSolicitacaoImutavel, statusLabelsEnum } from "../../utils/constants";
import { obterCategoriaDocumento } from "../../utils/categoriaDocumento";
import {
  abrirDocumentoArquivo,
  documentoEstaEnviado,
} from "../../utils/abrirDocumentoArquivo";
import { sxBlocoComentario } from "../../utils/sxBlocoComentario";
import { getApiErrorMessage } from "../../utils/getApiErrorMessage";
import AdicionarDocumentoModal from "../../components/AdicionarDocumentoModal";
import AdicionarCondicionanteModal from "../../components/AdicionarCondicionanteModal";
import ComentariosDeUmDocumento from "../../components/ComentariosDeUmDocumento";
import PagamentosSection, { PAPEL_ANALISTA } from "../../components/PagamentosSection";
import EditingLockBanner from "../../components/EditingLockBanner";
import useEditingLock from "../../hooks/useEditingLock";
import RamaPanel, { RamaAnaliseFields } from "../../components/RamaPanel";

import {
  CloudUpload as CloudUploadIcon,
  InsertDriveFile as FileIcon,
} from "@mui/icons-material";

const DetalheSolicitacaoAnalista = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [loadError, setLoadError] = useState(null);
  const [processoSelecionado, setProcessoSelecionado] = useState(null);
  const [novoStatus, setNovoStatus] = useState("");
  const [observacoes, setObservacoes] = useState("");
  const [documentosSolicitacao, setDocumentosSolicitacao] = useState([]);
  const [documentoSelecionado, setDocumentoSelecionado] = useState(null);
  const [comentarioDialogOpen, setComentarioDialogOpen] = useState(false);
  const [
    condicionanteComentarioDialogOpen,
    setCondicionanteComentarioDialogOpen,
  ] = useState(false);
  const [condicionanteSelecionado, setCondicionanteSelecionado] =
    useState(null);

  const [, setUploadDialogOpen] = useState(false);
  const [adicionarDocumentoDialogOpen, setAdicionarDocumentoDialogOpen] =
    useState(false);
  const [
    adicionarCondicionanteDialogOpen,
    setAdicionarCondicionanteDialogOpen,
  ] = useState(false);
  const [condicionantesSolicitacao, setCondicionantesSolicitacao] = useState(
    [],
  );
  const [loadingDocumentos, setLoadingDocumentos] = useState(false);
  const [dataValidade, setDataValidade] = useState("");
  const [possuiRama, setPossuiRama] = useState(false);
  const [intervaloRamaMeses, setIntervaloRamaMeses] = useState("");

  const lockEnabled = !!processoSelecionado?.id;
  const {
    isOwner: lockIsOwner,
    isLocked: lockIsLocked,
    lockedBy: lockOwnerInfo,
    lockedSince,
    forceUnlock: lockForceUnlock,
  } = useEditingLock(
    "SolicitacaoDeLicenca",
    lockEnabled ? processoSelecionado.id : null,
    lockEnabled,
  );
  const isReadOnly = lockIsLocked && !lockIsOwner;
  const solicitacaoImutavel = isSolicitacaoImutavel(processoSelecionado?.status);
  const edicaoBloqueada = isReadOnly || solicitacaoImutavel;

  const voltarAoDashboard = () => {
    navigate("/analista/dashboard");
  };

  const normalizarNomeDocumento = (nome) => {
    if (!nome) return "";

    let normalizado = nome.toLowerCase();

    normalizado = normalizado.replace(/[^\w\s]/g, " ");

    normalizado = normalizado.replace(
      /(checklist|documento de|doc\.|documento|arquivo)/g,
      "",
    );

    normalizado = normalizado.replace(/\s+/g, " ").trim();

    return normalizado;
  };

  const handleAbrirUploadDialog = (documento) => {
    if (documento.campo.startsWith("analista_")) {
      return;
    }
    setDocumentoSelecionado(documento);
    setUploadDialogOpen(true);
  };

  const handleAbrirAdicionarDocumentoDialog = () => {
    setAdicionarDocumentoDialogOpen(true);
  };

  const handleFecharAdicionarDocumentoDialog = () => {
    setAdicionarDocumentoDialogOpen(false);
  };

  const handleAbrirAdicionarCondicionanteDialog = () => {
    setAdicionarCondicionanteDialogOpen(true);
  };

  const handleFecharAdicionarCondicionanteDialog = () => {
    setAdicionarCondicionanteDialogOpen(false);
  };

  const handleDocumentoAdicionado = (documentos) => {
    setDocumentosSolicitacao(documentos);
  };

  const renderComentarios = (doc) => {
    if (!processoSelecionado || !processoSelecionado.comentarios) {
      return null;
    }

    const nomeDocNormalizado = normalizarNomeDocumento(doc.nome);

    if (
      processoSelecionado.comentarios &&
      Array.isArray(processoSelecionado.comentarios)
    ) {
      const comentarios = processoSelecionado.comentarios.filter((c) => {
        const nomeComentarioNormalizado = normalizarNomeDocumento(
          c.nome_documento,
        );

        const matchExato = c.nome_documento === doc.nome;

        const matchNormalizado =
          nomeDocNormalizado === nomeComentarioNormalizado;

        const nomeDocLowerCase = doc.nome.toLowerCase();
        const nomeComentarioLowerCase = c.nome_documento.toLowerCase();
        const matchParcial =
          nomeDocLowerCase.includes(nomeComentarioLowerCase) ||
          nomeComentarioLowerCase.includes(nomeDocLowerCase) ||
          nomeDocNormalizado.includes(nomeComentarioNormalizado) ||
          nomeComentarioNormalizado.includes(nomeDocNormalizado);

        return matchExato || matchNormalizado || matchParcial;
      });

      if (comentarios.length > 0) {
        return comentarios.map((comentario, index) => (
          <Box
            key={index}
            sx={sxBlocoComentario(processoSelecionado.status)}
          >
            <Typography variant="body2" fontWeight="medium">
              <strong>Comentário:</strong> {comentario.comentario}
            </Typography>
            <Typography variant="caption">
              {new Date(comentario.data_criacao).toLocaleString()}
            </Typography>
          </Box>
        ));
      } else {
        return null;
      }
    }

    if (
      processoSelecionado.analise &&
      processoSelecionado.analise.comentarios
    ) {
      const comentarios = processoSelecionado.analise.comentarios.filter(
        (c) => {
          const nomeComentarioNormalizado = normalizarNomeDocumento(
            c.nome_documento,
          );

          const matchExato = c.nome_documento === doc.nome;

          const matchNormalizado =
            nomeDocNormalizado === nomeComentarioNormalizado;

          const nomeDocLowerCase = doc.nome.toLowerCase();
          const nomeComentarioLowerCase = c.nome_documento.toLowerCase();
          const matchParcial =
            nomeDocLowerCase.includes(nomeComentarioLowerCase) ||
            nomeComentarioLowerCase.includes(nomeDocLowerCase) ||
            nomeDocNormalizado.includes(nomeComentarioNormalizado) ||
            nomeComentarioNormalizado.includes(nomeDocNormalizado);

          return matchExato || matchNormalizado || matchParcial;
        },
      );

      if (comentarios.length > 0) {
        return comentarios.map((comentario, index) => (
          <Box
            key={index}
            sx={sxBlocoComentario(processoSelecionado.status)}
          >
            <Typography variant="body2" fontWeight="medium">
              <strong>Comentário do Analista:</strong> {comentario.comentario}
            </Typography>
            <Typography variant="caption">
              {new Date(comentario.data_criacao).toLocaleString()}
            </Typography>
          </Box>
        ));
      } else {
        return null;
      }
    }

    return null;
  };

  const handleAbrirComentarioDialog = (doc) => {
    setDocumentoSelecionado(doc);
    setComentarioDialogOpen(true);
  };

  const handleFecharComentarioDialog = () => {
    setComentarioDialogOpen(false);
    setDocumentoSelecionado(null);
  };

  const handleAbrirCondicionanteComentarioDialog = (condicionante) => {
    setCondicionanteSelecionado(condicionante);
    setCondicionanteComentarioDialogOpen(true);
  };

  const handleFecharCondicionanteComentarioDialog = () => {
    setCondicionanteComentarioDialogOpen(false);
    setCondicionanteSelecionado(null);
  };

  const obterTodosDocumentos = async (idDaSolicitacao) => {
    try {
      const response = await api.get(
        `/documento/solicitacao/${idDaSolicitacao}`,
      );

      if (response.data && response.data.data) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      return [];
    }
  };

  const obterTodosCondicionantes = async (idDaSolicitacao) => {
    try {
      const response = await api.get(
        `Condicionante/solicitacao/${idDaSolicitacao}`,
      );

      if (response.data && response.data.data) {
        return response.data.data;
      }

      return [];
    } catch (error) {
      return [];
    }
  };

  const handleAtualizarSolicitacao = async () => {
    try {
      if (
        novoStatus === "" ||
        novoStatus === null ||
        novoStatus === undefined
      ) {
        alert("Por favor, selecione um status para análise.");
        return;
      }

      if (
        Number(novoStatus) === statusLabelsEnum.AGUARDANDO_APROVACAO &&
        !dataValidade
      ) {
        alert(
          "Informe a data de validade da licença antes de enviar para aprovação.",
        );
        return;
      }

      if (possuiRama && (!intervaloRamaMeses || Number(intervaloRamaMeses) < 1)) {
        alert("Informe o intervalo em meses entre as entregas de RAMA.");
        return;
      }

      await licencasService.atualizarSolicitacaoAnalista(
        processoSelecionado.id,
        novoStatus,
        observacoes,
        processoSelecionado.rowVersion,
        {
          dataValidade: dataValidade || undefined,
          possuiRama,
          intervaloRamaMeses: possuiRama
            ? Number(intervaloRamaMeses)
            : undefined,
        },
      );

      alert("Análise atualizada com sucesso!");
      voltarAoDashboard();
    } catch (error) {
      alert(
        error.message ||
          "Erro ao atualizar análise. Tente novamente mais tarde.",
      );
    }
  };

  const carregarDocumentos = async () => {
    if (!processoSelecionado?.id) return;

    const documentos = await obterTodosDocumentos(processoSelecionado.id);
    setDocumentosSolicitacao(documentos);
  };

  const carregarCondicionantes = async () => {
    if (!processoSelecionado?.id) return;

    const condicionantes = await obterTodosCondicionantes(
      processoSelecionado.id,
    );
    setCondicionantesSolicitacao(condicionantes);
  };


  useEffect(() => {
    let cancelled = false;
    const carregar = async () => {
      try {
        setLoading(true);
        setLoadError(null);
        const data = await licencasService.obterSolicitacao(id);
        if (!cancelled) {
          setProcessoSelecionado(data);
        }
      } catch (error) {
        if (!cancelled) {
          const status = error?.status || error?.response?.status;
          if (status === 404) {
            setLoadError("not_found");
          } else if (status === 403) {
            setLoadError("forbidden");
          } else {
            setLoadError("generic");
          }
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    if (id) carregar();
    return () => {
      cancelled = true;
    };
  }, [id]);

  useEffect(() => {
    if (!processoSelecionado?.id) return;

    let cancelled = false;

    setNovoStatus(processoSelecionado.status);
    setDataValidade(
      processoSelecionado.dataValidade
        ? String(processoSelecionado.dataValidade).slice(0, 10)
        : "",
    );
    setPossuiRama(!!processoSelecionado.possuiRama);
    setIntervaloRamaMeses(
      processoSelecionado.intervaloRamaMeses
        ? String(processoSelecionado.intervaloRamaMeses)
        : "",
    );
    setLoadingDocumentos(true);

    Promise.all([
      obterTodosDocumentos(processoSelecionado.id),
      obterTodosCondicionantes(processoSelecionado.id),
    ]).then(([documentos, condicionantes]) => {
      if (!cancelled) {
        setDocumentosSolicitacao(documentos);
        setCondicionantesSolicitacao(condicionantes);
        setLoadingDocumentos(false);
      }
    });

    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [processoSelecionado?.id]);

  useEffect(() => {
    if (adicionarCondicionanteDialogOpen === false && processoSelecionado?.id) {
      carregarCondicionantes();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [adicionarCondicionanteDialogOpen]);

  if (loading) {
    return (
      <Container maxWidth="xl" sx={{ py: 6, textAlign: "center" }}>
        <CircularProgress />
        <Typography variant="body2" color="text.secondary" sx={{ mt: 2 }}>
          Carregando solicitação...
        </Typography>
      </Container>
    );
  }

  if (loadError || !processoSelecionado) {
    const mensagem =
      loadError === "forbidden"
        ? "Você não tem permissão para acessar esta solicitação."
        : loadError === "not_found"
          ? "Solicitação não encontrada."
          : "Erro ao carregar a solicitação.";
    return (
      <Container maxWidth="xl" sx={{ py: 4 }}>
        <Alert severity="error" sx={{ mb: 2 }}>
          {mensagem}
        </Alert>
        <Button startIcon={<ArrowBackIcon />} onClick={voltarAoDashboard}>
          Voltar ao dashboard
        </Button>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl" sx={{ py: 3, pb: 10 }}>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems={{ xs: "flex-start", sm: "center" }}
        justifyContent="space-between"
        sx={{ mb: 3 }}
      >
        <Box>
          <Button
            startIcon={<ArrowBackIcon />}
            onClick={voltarAoDashboard}
            sx={{ mb: 1 }}
          >
            Voltar
          </Button>
          <Typography variant="h5" component="h1" fontWeight={600}>
            Análise do Processo — {processoSelecionado.nomeTipoLicenca} —{" "}
            {processoSelecionado.empreendimento?.nome}
          </Typography>
        </Box>
      </Stack>

      {lockIsLocked && !lockIsOwner && (
        <EditingLockBanner
          lockedBy={lockOwnerInfo}
          lockedSince={lockedSince}
          canForceUnlock
          onForceUnlock={lockForceUnlock}
        />
      )}

      <Box sx={{ position: "relative" }}>
        {loadingDocumentos && (
          <Box
            sx={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              bgcolor: (theme) => alpha(theme.palette.background.paper, 0.9),
              zIndex: 10,
              gap: 2,
            }}
            data-testid="overlay-carregando-documentos"
          >
            <CircularProgress />
            <Typography variant="body2" color="text.secondary">
              Carregando documentos...
            </Typography>
          </Box>
        )}

        <SolicitacaoResumoHeader solicitacao={processoSelecionado} />

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3 },
            height: { xs: "auto", md: 480 },
            maxHeight: { xs: 420, md: 480 },
            display: "flex",
            flexDirection: "column",
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", sm: "center" }}
            justifyContent="space-between"
            sx={{ mb: 2, flexShrink: 0 }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Documentos da Licença
            </Typography>
            <Button
              variant="contained"
              color="primary"
              startIcon={<CloudUploadIcon />}
              onClick={handleAbrirAdicionarDocumentoDialog}
              size="small"
              disabled={solicitacaoImutavel}
              sx={{ alignSelf: { xs: "stretch", sm: "auto" } }}
            >
              Adicionar Documento
            </Button>
          </Stack>
          <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pr: 0.5 }}>
            <List disablePadding>
              {(() => {
                const documentosProcessados = new Set();
                const documentosUnicos = [];
                const adicionarDocumentoUnico = (doc) => {
                  if (!documentosProcessados.has(doc.id)) {
                    documentosProcessados.add(doc.id);
                    documentosUnicos.push(doc);
                    return true;
                  }
                  return false;
                };
                if (
                  documentosSolicitacao &&
                  Array.isArray(documentosSolicitacao)
                ) {
                  documentosSolicitacao.forEach((doc) => {
                    if (doc.data) {
                      const documento = {
                        id: doc.data,
                        nome: doc.fileName,
                        campo: `solicitacao_${doc.data}`,
                        enviado: documentoEstaEnviado(doc.status),
                        tamanho: doc.sizeBytes,
                        tipo: doc.contextType,
                        dataCriacao: doc.createAt,
                        processoSelecionado: true,
                        hasMessages: doc.hasMessages,
                      };
                      adicionarDocumentoUnico(documento);
                    }
                  });
                }

                return documentosUnicos.map((doc, index) => {
                  const categoria = obterCategoriaDocumento(
                    doc.campo,
                    doc.enviado,
                  );
                  return (
                    <ListItem
                      key={`doc-${index}`}
                      alignItems="flex-start"
                      sx={{
                        flexDirection: "column",
                        alignItems: "stretch",
                        gap: 1.5,
                        borderLeft: categoria ? "4px solid" : "4px solid transparent",
                        borderLeftColor: categoria?.borderColor || "transparent",
                        mb: 1.5,
                        px: { xs: 1.5, sm: 2 },
                        py: 1.75,
                        borderRadius: 1.5,
                        bgcolor: "action.hover",
                      }}
                    >
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1.5}
                        alignItems={{ xs: "stretch", sm: "flex-start" }}
                        justifyContent="space-between"
                        sx={{ width: "100%" }}
                      >
                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="flex-start"
                          sx={{ minWidth: 0, flex: 1 }}
                        >
                          <Box sx={{ pt: 0.25, flexShrink: 0 }}>
                            {categoria ? (
                              <Badge color={categoria.badgeColor} variant="dot">
                                <FileIcon
                                  role="img"
                                  aria-label={categoria.ariaLabel}
                                  color="action"
                                />
                              </Badge>
                            ) : (
                              <FileIcon color="action" />
                            )}
                          </Box>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 500,
                                wordBreak: "break-word",
                                mb: categoria ? 1 : 0,
                              }}
                            >
                              {doc.nome}
                            </Typography>
                            {categoria && (
                              <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
                                <Chip
                                  size="small"
                                  label={categoria.label}
                                  color={categoria.chipColor}
                                  variant="outlined"
                                />
                                <Chip
                                  size="small"
                                  label={categoria.statusLabel}
                                  color={categoria.statusColor}
                                  variant="outlined"
                                />
                              </Stack>
                            )}
                          </Box>
                        </Stack>

                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="center"
                          flexWrap="wrap"
                          useFlexGap
                          sx={{
                            flexShrink: 0,
                            pl: { sm: 1 },
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                          }}
                        >
                          {doc.enviado ? (
                            <>
                              <Button
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<FileIcon />}
                                onClick={async () => {
                                  try {
                                    await abrirDocumentoArquivo(doc.id);
                                  } catch (error) {
                                    alert(
                                      getApiErrorMessage(
                                        error,
                                        "Não foi possível abrir o documento.",
                                      ),
                                    );
                                  }
                                }}
                              >
                                VISUALIZAR
                              </Button>
                              <Tooltip title="Adicionar comentário">
                                <IconButton
                                  size="small"
                                  aria-label="Adicionar comentário"
                                  onClick={() =>
                                    handleAbrirComentarioDialog(doc)
                                  }
                                >
                                  <Badge
                                    badgeContent={doc.hasMessages ? "!" : 0}
                                    color="error"
                                  >
                                    <CommentIcon />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                              {processoSelecionado?.status ===
                                "SOLICITANDO_INFORMACOES" &&
                                !doc.campo.startsWith("analista_") &&
                                !doc.campo.startsWith("solicitacao_") && (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="primary"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() =>
                                      handleAbrirUploadDialog(doc)
                                    }
                                  >
                                    REENVIAR
                                  </Button>
                                )}
                            </>
                          ) : (
                            <>
                              <Button
                                disabled
                                size="small"
                                variant="outlined"
                                color="primary"
                                startIcon={<FileIcon />}
                              >
                                NÃO ENVIADO
                              </Button>
                              {processoSelecionado?.status ===
                                "SOLICITANDO_INFORMACOES" &&
                                !doc.campo.startsWith("analista_") && (
                                  <Button
                                    size="small"
                                    variant="contained"
                                    color="warning"
                                    startIcon={<CloudUploadIcon />}
                                    onClick={() =>
                                      handleAbrirUploadDialog(doc)
                                    }
                                  >
                                    ENVIAR
                                  </Button>
                                )}
                            </>
                          )}
                        </Stack>
                      </Stack>
                      {renderComentarios(doc)}
                    </ListItem>
                  );
                });
              })()}
            </List>
          </Box>
        </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 3 },
            height: { xs: "auto", md: 480 },
            maxHeight: { xs: 420, md: 480 },
            display: "flex",
            flexDirection: "column",
            border: 1,
            borderColor: "divider",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={1.5}
            alignItems={{ xs: "stretch", sm: "center" }}
            justifyContent="space-between"
            sx={{ mb: 2, flexShrink: 0 }}
          >
            <Typography variant="h6" sx={{ fontWeight: 600 }}>
              Condicionantes da Licença
            </Typography>
            <Button
              variant="contained"
              color="secondary"
              startIcon={<CloudUploadIcon />}
              onClick={handleAbrirAdicionarCondicionanteDialog}
              size="small"
              disabled={solicitacaoImutavel}
              sx={{ alignSelf: { xs: "stretch", sm: "auto" } }}
            >
              Adicionar Condicionante
            </Button>
          </Stack>
          {condicionantesSolicitacao &&
          condicionantesSolicitacao.length > 0 ? (
            <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pr: 0.5 }}>
              <List disablePadding>
                {condicionantesSolicitacao.map((condicionante, index) => {
                  const isCondicionantePendente = condicionante.status === 1;
                  return (
                    <ListItem
                      key={`cond-${index}`}
                      alignItems="flex-start"
                      sx={{
                        flexDirection: "column",
                        alignItems: "stretch",
                        gap: 1.5,
                        borderLeft: "4px solid",
                        borderLeftColor: isCondicionantePendente
                          ? "warning.main"
                          : "success.main",
                        mb: 1.5,
                        px: { xs: 1.5, sm: 2 },
                        py: 1.75,
                        borderRadius: 1.5,
                        bgcolor: "action.hover",
                      }}
                    >
                      <Stack
                        direction={{ xs: "column", sm: "row" }}
                        spacing={1.5}
                        alignItems={{ xs: "stretch", sm: "flex-start" }}
                        justifyContent="space-between"
                        sx={{ width: "100%" }}
                      >
                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="flex-start"
                          sx={{ minWidth: 0, flex: 1 }}
                        >
                          <Box sx={{ pt: 0.25, flexShrink: 0 }}>
                            <Badge
                              color={
                                isCondicionantePendente ? "warning" : "success"
                              }
                              variant="dot"
                            >
                              <FileIcon
                                role="img"
                                aria-label={
                                  isCondicionantePendente
                                    ? "Condicionante pendente"
                                    : "Condicionante atendido"
                                }
                                color="action"
                              />
                            </Badge>
                          </Box>
                          <Box sx={{ minWidth: 0, flex: 1 }}>
                            <Typography
                              variant="body1"
                              sx={{ fontWeight: 500, wordBreak: "break-word" }}
                            >
                              {condicionante.fileName}
                            </Typography>
                            {condicionante.status ===
                              statusLabelsEnum.ANALISTA_ANALISANDO && (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                Status: Pendente
                              </Typography>
                            )}
                            {condicionante.dataAtendimento && (
                              <Typography
                                variant="caption"
                                color="text.secondary"
                                sx={{ display: "block", mt: 0.5 }}
                              >
                                Atendido em:{" "}
                                {new Date(
                                  condicionante.dataAtendimento,
                                ).toLocaleDateString("pt-BR")}
                              </Typography>
                            )}
                          </Box>
                        </Stack>

                        <Stack
                          direction="row"
                          spacing={1.5}
                          alignItems="center"
                          flexWrap="wrap"
                          useFlexGap
                          sx={{
                            flexShrink: 0,
                            justifyContent: { xs: "flex-start", sm: "flex-end" },
                          }}
                        >
                          {condicionante.status ===
                          statusLabelsEnum.ANALISTA_ANALISANDO ? (
                            <Tooltip title="Ver comentários">
                              <IconButton
                                size="small"
                                aria-label="Ver comentários"
                                onClick={() =>
                                  handleAbrirCondicionanteComentarioDialog(
                                    condicionante,
                                  )
                                }
                              >
                                <Badge
                                  badgeContent={
                                    condicionante.hasMessages ? "!" : 0
                                  }
                                  color="error"
                                >
                                  <CommentIcon fontSize="small" />
                                </Badge>
                              </IconButton>
                            </Tooltip>
                          ) : (
                            <>
                              {condicionante.conteudo && (
                                <Button
                                  href={(() => {
                                    const mimeType =
                                      condicionante.contextType ||
                                      "application/pdf";
                                    const byteCharacters = atob(
                                      condicionante.conteudo,
                                    );
                                    const byteNumbers = new Array(
                                      byteCharacters.length,
                                    );
                                    for (
                                      let i = 0;
                                      i < byteCharacters.length;
                                      i++
                                    ) {
                                      byteNumbers[i] =
                                        byteCharacters.charCodeAt(i);
                                    }
                                    const byteArray = new Uint8Array(
                                      byteNumbers,
                                    );
                                    const blob = new Blob([byteArray], {
                                      type: mimeType,
                                    });
                                    return URL.createObjectURL(blob);
                                  })()}
                                  target="_blank"
                                  size="small"
                                  variant="outlined"
                                  color="success"
                                  startIcon={<FileIcon />}
                                  sx={{ textTransform: "none" }}
                                >
                                  Visualizar Resposta
                                </Button>
                              )}
                              <Tooltip title="Ver comentários">
                                <IconButton
                                  size="small"
                                  aria-label="Ver comentários"
                                  onClick={() =>
                                    handleAbrirCondicionanteComentarioDialog(
                                      condicionante,
                                    )
                                  }
                                >
                                  <Badge
                                    badgeContent={
                                      condicionante.hasMessages ? "!" : 0
                                    }
                                    color="error"
                                  >
                                    <CommentIcon fontSize="small" />
                                  </Badge>
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                        </Stack>
                      </Stack>
                    </ListItem>
                  );
                })}
              </List>
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary">
              Nenhum condicionante cadastrado para esta solicitação.
            </Typography>
          )}
        </Paper>
          </Grid>
        </Grid>

        <Grid container spacing={2} sx={{ mb: 3 }}>
          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 2, sm: 3 },
                height: { xs: "auto", md: 480 },
                maxHeight: { xs: 420, md: 480 },
                display: "flex",
                flexDirection: "column",
                border: 1,
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pr: 0.5 }}>
                <PagamentosSection
                  solicitacao={processoSelecionado}
                  papel={PAPEL_ANALISTA}
                />
              </Box>
            </Paper>
          </Grid>

          <Grid item xs={12} md={6}>
            <Paper
              elevation={0}
              sx={{
                p: { xs: 2, sm: 3 },
                height: { xs: "auto", md: 480 },
                maxHeight: { xs: 420, md: 480 },
                display: "flex",
                flexDirection: "column",
                border: 1,
                borderColor: "divider",
                borderRadius: 2,
                overflow: "hidden",
              }}
            >
              <Typography variant="h6" sx={{ mb: 2, fontWeight: 600, flexShrink: 0 }}>
                Análise
              </Typography>
              <Box sx={{ flex: 1, minHeight: 0, overflowY: "auto", pr: 0.5, pt: 1 }}>
            <RamaAnaliseFields
              solicitacaoId={processoSelecionado?.id}
              dataValidade={dataValidade}
              setDataValidade={setDataValidade}
              possuiRama={possuiRama}
              setPossuiRama={setPossuiRama}
              intervaloRamaMeses={intervaloRamaMeses}
              setIntervaloRamaMeses={setIntervaloRamaMeses}
              disabled={edicaoBloqueada}
            />
            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Status</InputLabel>
              <Select
                value={novoStatus}
                onChange={(e) => setNovoStatus(e.target.value)}
                label="Status"
                disabled={edicaoBloqueada}
              >
                <MenuItem value={statusLabelsEnum.AGUARDANDO_ANALISE}>
                  Aguardando Análise
                </MenuItem>
                <MenuItem value={statusLabelsEnum.ANALISTA_ANALISANDO}>
                  Analista Analisando
                </MenuItem>
                <MenuItem value={statusLabelsEnum.SOLICITANDO_INFORMACOES}>
                  Solicitar Informações
                </MenuItem>
                <MenuItem value={statusLabelsEnum.AGUARDANDO_PAGAMENTO}>
                  Aguardando Pagamento
                </MenuItem>
                <MenuItem value={statusLabelsEnum.PAGAMENTO_EFETUADO}>
                  Pagamento Efetuado
                </MenuItem>
                <MenuItem value={statusLabelsEnum.AGUARDANDO_APROVACAO}>
                  Aguardando Aprovação
                </MenuItem>
                <MenuItem value={statusLabelsEnum.APROVADA} disabled>
                  Aprovada
                </MenuItem>
                <MenuItem value={statusLabelsEnum.REJEITADA} disabled>
                  Rejeitada
                </MenuItem>
                <MenuItem value={statusLabelsEnum.CORRECAO} disabled>
                  Correção
                </MenuItem>
                <MenuItem value={statusLabelsEnum.LICENCA_EMITIDA} disabled>
                  Licença Emitida
                </MenuItem>
                <MenuItem value={statusLabelsEnum.LICENCA_ASSINADA} disabled>
                  Licença Assinada
                </MenuItem>
                <MenuItem value={statusLabelsEnum.LICENCA_CANCELADA}>
                  Licença Cancelada
                </MenuItem>
              </Select>
            </FormControl>
            <TextField
              fullWidth
              multiline
              rows={4}
              label="Observações"
              value={observacoes}
              onChange={(e) => setObservacoes(e.target.value)}
              sx={{ mb: 2 }}
              disabled={edicaoBloqueada}
            />
            <RamaPanel
              solicitacaoId={processoSelecionado?.id}
              papel="analista"
              licencaEmitida={
                processoSelecionado?.status ===
                  statusLabelsEnum.LICENCA_EMITIDA ||
                processoSelecionado?.status ===
                  statusLabelsEnum.LICENCA_ASSINADA
              }
            />
              </Box>
            </Paper>
          </Grid>
        </Grid>
      </Box>

      <Paper
        elevation={3}
        sx={{
          position: "sticky",
          bottom: 16,
          mt: 3,
          p: 2,
          display: "flex",
          justifyContent: "flex-end",
          gap: 1,
          zIndex: 5,
        }}
      >
        <Button onClick={voltarAoDashboard}>Voltar</Button>
        <Button
          onClick={handleAtualizarSolicitacao}
          variant="contained"
          color="primary"
          disabled={edicaoBloqueada}
        >
          Salvar Análise
        </Button>
      </Paper>

      <AdicionarDocumentoModal
        open={adicionarDocumentoDialogOpen}
        onClose={handleFecharAdicionarDocumentoDialog}
        onDocumentoAdicionado={handleDocumentoAdicionado}
        processoSelecionado={processoSelecionado}
      />

      <AdicionarCondicionanteModal
        open={adicionarCondicionanteDialogOpen}
        onClose={handleFecharAdicionarCondicionanteDialog}
        processoSelecionado={processoSelecionado}
      />

      <ComentariosDeUmDocumento
        open={comentarioDialogOpen}
        onClose={handleFecharComentarioDialog}
        documento={documentoSelecionado}
        processo={processoSelecionado}
        onComentarioSalvo={() => carregarDocumentos()}
      />

      <ComentariosDeUmDocumento
        open={condicionanteComentarioDialogOpen}
        onClose={handleFecharCondicionanteComentarioDialog}
        documento={condicionanteSelecionado}
        processo={processoSelecionado}
        onComentarioSalvo={() => carregarCondicionantes()}
        tipoRecurso="condicionantes"
      />
    </Container>
  );
};

export default DetalheSolicitacaoAnalista;
